import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';

const SiteFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <BrandMark to="/" />
          <p className="mt-4 text-sm text-ink-muted max-w-md leading-relaxed">
            Prêt de livres entre particuliers à Bruxelles. Remise dans un lieu ouvert,
            caution bloquée, retour validé. Un complément à la bibliothèque publique — pas un substitut.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-widest uppercase text-ink-muted mb-3">Produit</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#confiance" className="text-ink-muted hover:text-ink">Protection</Link></li>
            <li><Link to="/#lieux" className="text-ink-muted hover:text-ink">Lieux partenaires</Link></li>
            <li><Link to="/#tarifs" className="text-ink-muted hover:text-ink">Tarifs</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-widest uppercase text-ink-muted mb-3">Informations</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/cgu" className="text-ink-muted hover:text-ink">Conditions d’utilisation</Link></li>
            <li><Link to="/legal/confidentialite" className="text-ink-muted hover:text-ink">Confidentialité</Link></li>
            <li><Link to="/legal/garantie" className="text-ink-muted hover:text-ink">Charte de garantie</Link></li>
            <li><Link to="/partenaires" className="text-ink-muted hover:text-ink">Partenariats bibliothèques</Link></li>
            <li><Link to="/partenaires/dossier" className="text-ink-muted hover:text-ink">Dossier pilote (1 page)</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-200 py-4 text-center text-xs text-ink-faint">
        Ville pilote Bruxelles · BookShare {new Date().getFullYear()}
      </div>
    </footer>
  );
};

export default SiteFooter;
